import { Dispatch, SetStateAction } from 'react';
import {
  formatDate,
  getMonths,
  validateLeftButton,
  validateRightButton,
  INIT_END_DATE,
  INIT_START_DATE
} from '../helper';
import { getButtonClass } from '../helper';
import Month from './Month';
import { DateRange } from '../../../types';

import { ReactComponent as ArrowLeftIcon } from '../../../assets/icons/chevron-left.svg';
import { ReactComponent as ArrowRightIcon } from '../../../assets/icons/chevron-right.svg';

interface Props {
  variant: string;
  minYear: number;
  maxYear: number;
  startDate: string;
  setStartDate: Dispatch<SetStateAction<string>>;
  endDate: string;
  setEndDate: Dispatch<SetStateAction<string>>;
  startYear: number;
  setStartYear: Dispatch<SetStateAction<number>>;
  endYear: number;
  setEndYear: Dispatch<SetStateAction<number>>;
  disabledLeftBtnLeftVariant: boolean;
  disabledRightBtnLeftVariant: boolean;
  disabledLeftBtnRighttVariant: boolean;
  disabledRightBtnRighttVariant: boolean;
  rangeLimit: Array<DateRange>;
}

const Calender = ({
  variant,
  minYear,
  maxYear,
  startDate,
  setStartDate,
  endDate,
  setEndDate,
  startYear,
  setStartYear,
  endYear,
  setEndYear,
  disabledLeftBtnLeftVariant,
  disabledRightBtnLeftVariant,
  disabledLeftBtnRighttVariant,
  disabledRightBtnRighttVariant,
  rangeLimit
}: Props) => {
  const months = getMonths();
  // left year button clicked
  const leftClicked = () => {
    if (validateLeftButton(variant, startYear, endYear, minYear)) {
      switch (variant) {
        case 'left': {
          setStartYear((y) => y - 1);
          break;
        }
        case 'right': {
          setEndYear((y) => y - 1);
          if (startYear + 1 === endYear && validateLeftButton('left', startYear, endYear, minYear)) {
            setStartYear((y) => y - 1);
          }
          break;
        }
      }
    }
  };

  // right year button clicked
  const rightClicked = () => {
    if (validateRightButton(variant, startYear, endYear, maxYear)) {
      switch (variant) {
        case 'left': {
          // left calendar
          setStartYear((y) => y + 1); // start year increase
          if (
            // check if start year is greater than end year
            startYear + 1 === endYear &&
            validateRightButton('right', startYear, endYear, maxYear)
          ) {
            setEndYear((y) => y + 1);
          }
          break;
        }
        case 'right': {
          // right calendar
          setEndYear((y) => y + 1);
          break;
        }
      }
    }
  };

  // month is selected
  const monthClicked = (e: any) => {
    const clickedMonth = e.target.innerHTML;
    if (startDate === INIT_START_DATE) {
      setStartDate(`${clickedMonth} ${variant === 'left' ? startYear : endYear}`);
    } else {
      if (endDate === INIT_END_DATE) {
        const end = `${clickedMonth} ${variant === 'left' ? startYear : endYear}`;
        if (formatDate(startDate) > formatDate(end)) {
          setEndDate(startDate);
          setStartDate(end);
        } else setEndDate(end);
      } else {
        setStartDate(`${clickedMonth} ${variant === 'left' ? startYear : endYear}`);
        setEndDate(INIT_END_DATE);
      }
    }
  };

  return (
    <div className="py-3 px-1">
      <div className="flex justify-between items-center text-sm font-nunitoBold px-1 pt-1">
        <button
          className={getButtonClass(variant, disabledLeftBtnLeftVariant, disabledLeftBtnRighttVariant)}
          onClick={leftClicked}
          disabled={variant === 'left' ? disabledLeftBtnLeftVariant : disabledLeftBtnRighttVariant}
        >
          <ArrowLeftIcon />
        </button>
        <div>{variant === 'left' ? startYear : endYear}</div>
        <button
          className={getButtonClass(variant, disabledRightBtnLeftVariant, disabledRightBtnRighttVariant)}
          onClick={rightClicked}
          disabled={variant === 'left' ? disabledRightBtnLeftVariant : disabledRightBtnRighttVariant}
        >
          <ArrowRightIcon />
        </button>
      </div>
      <div className="grid grid-cols-4 gap-[4px] px-2 py-1">
        {months.map((month, key) => (
          <Month
            key={key}
            {...{
              month,
              variant,
              startDate,
              endDate,
              startYear,
              endYear,
              monthClicked,
              rangeLimit
            }}
          />
        ))}
      </div>
    </div>
  );
};

export default Calender;
